// convert px to rem
export const rem = px => {
  return `${px / 100}rem`
}

// 设计像素换算实际像素
export const px2RootPx = px => {
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
  return px / 100 * rootFontSize
}